import { ABSOLUTE, CENTER, EASE, HIDE, SHOW, Y } from '../base/helpers/style'
import { CS } from '../base/utils/styler'

export default {
    PAGE_TRANSITION_DURATION: 160,
    PAGE_BASE: {
        ...HIDE,
        ...ABSOLUTE,
        ...CENTER,
        ...EASE(.12),
        justifyContent: 'center',
        top: '0',
        paddingTop: 'calc(env(safe-area-inset-top) + 0px)',
        zIndex: '9999',
        flexDirection: 'column',
    },
    PAGE_EXIT: {
        ...HIDE,

    },
    PAGE_ENTER: {
        ...SHOW,

    },
    PAGE_EXIT_UP: {
        ...HIDE,

    },
    PAGE_EXIT_DESKTOP: {
        ...HIDE,

    },
    PAGE_ENTER_DESKTOP: {
        ...SHOW,

    },
} as {
    PAGE_BASE: CS
    PAGE_EXIT: CS
    PAGE_ENTER: CS
    PAGE_EXIT_UP: CS
    PAGE_EXIT_DESKTOP: CS
    PAGE_ENTER_DESKTOP: CS
    PAGE_TRANSITION_DURATION: number
}
